"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _CwPill = _interopRequireDefault(require("./CwPill.scss"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));
/** @type {React.StatelessComponent} */


var CwPill = function CwPill(_ref) {
  var id = _ref.id,
      value = _ref.value,
      _ref$deletePillIcon = _ref.deletePillIcon,
      deletePillIcon = _ref$deletePillIcon === void 0 ? null : _ref$deletePillIcon,
      _ref$onDeletePill = _ref.onDeletePill,
      onDeletePill = _ref$onDeletePill === void 0 ? null : _ref$onDeletePill,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  return _react.default.createElement("span", {
    className: className ? className : _CwPill.default.pill,
    key: id
  }, value, onDeletePill ? _react.default.createElement(_CwImage.default, {
    onClick: function onClick() {
      onDeletePill({
        id: id,
        value: value
      });
    },
    className: _CwPill.default.closeIcon,
    isInlineSVG: false,
    src: deletePillIcon
  }) : null);
};

CwPill.propTypes = {
  /**
   * The key to be used for this pill
   */
  id: _propTypes.default.any.isRequired,

  /**
   * The value to display on the pill
   */
  value: _propTypes.default.string.isRequired,

  /**
  * The icon to display on the pill
  */
  deletePillIcon: _propTypes.default.string,

  /**
  * The function to be called when the pill is closed
  */
  onDeletePill: _propTypes.default.func,

  /**
  * CSS to override default
  */
  className: _propTypes.default.any
};
CwPill.defaultProps = {
  deletePillIcon: _IconPath.default.get('Action_Close')
};
var _default = CwPill;
exports.default = _default;